import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { fmtEUR } from "../lib/format";

// Palette derived from Amdir brand + complementary neutrals
const COLORS = ["var(--brand-primary)", "#E8935C", "#3B82F6", "#10B981", "#8B5CF6", "#F59E0B", "#EF4444", "#6B7280", "#EC4899"];

export default function RevenuePie() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/dashboard/revenue-by-client").then((r) => setData(r.data.slice(0, 8))); }, []);

  const total = data.reduce((s, d) => s + Number(d.value || 0), 0);

  return (
    <div className="border border-neutral-200 bg-white p-6" data-testid="revenue-pie">
      <div className="mb-4">
        <div className="mono-label">Dependency Risk</div>
        <h2 className="font-display text-xl font-medium mt-1">Ripartizione parcella per cliente</h2>
      </div>
      {data.length === 0 ? (
        <div className="text-center text-sm text-neutral-500 py-10">Nessuna gara ancora.</div>
      ) : (
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="w-full md:w-64 h-64 relative">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  innerRadius={62}
                  outerRadius={100}
                  stroke="#fff"
                  strokeWidth={2}
                  paddingAngle={1}
                >
                  {data.map((d, i) => <Cell key={d.client_id || d.name} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip
                  contentStyle={{ border: "1px solid #e5e5e5", borderRadius: 2, fontSize: 12, fontFamily: "IBM Plex Sans" }}
                  formatter={(v, n) => [fmtEUR(v), n]}
                />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <div className="mono-label">Totale</div>
              <div className="font-mono font-semibold text-sm mt-1">{fmtEUR(total)}</div>
            </div>
          </div>
          <div className="flex-1 min-w-0 w-full space-y-1.5">
            {data.map((d, i) => (
              <div key={d.client_id} className="flex items-center gap-2 text-xs">
                <div className="h-2.5 w-2.5 flex-shrink-0" style={{ background: COLORS[i % COLORS.length] }} />
                <div className="flex-1 truncate">{d.name}</div>
                <div className="font-mono text-neutral-600 tabular-nums">{fmtEUR(d.value)}</div>
                <div className="mono-label w-10 text-right">{total > 0 ? ((d.value / total) * 100).toFixed(1) : "0"}%</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
